import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push, replace } from 'connected-react-router'

import {
  doGetPopupModal,
  doClose,
  doNavigate,
} from '../../../controllers/PopupModal'

import {
  setAccountStatus,
  displayProfileModal,
  setTransportationMall,
  setProfileModalPage,
  setProfileModalDetailPage,
} from '../../../modules/profile/actions/creators'

import MainView from '../components/MainView/MainView'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { advanceAccount } = profile
  return {
    accessToken,
    advanceAccount,
    doGetPopupModal,
    doClose,
    doNavigate,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccountStatus,
      displayProfileModal,
      setTransportationMall,
      setProfileModalPage,
      setProfileModalDetailPage,
      push,
      replace,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
